import { bulkSetField } from '../api/channelBulk';
import type { ChannelRow } from '../api/channels';
import { parseShiftFromName } from './parseShiftFromName';

export async function applyEpgShiftFromNamesForChannels(
  playlistId: string,
  list: ChannelRow[],
): Promise<number> {
  const tokenPid = Number.parseInt(String(playlistId), 10);
  if (!Number.isFinite(tokenPid) || tokenPid <= 0) return 0;

  const updates: { id: number; value: number }[] = [];
  for (const ch of list) {
    const parsed = parseShiftFromName(ch.name);
    const cur = Math.max(-36, Math.min(36, Number(ch.shift ?? 0) || 0));
    if (parsed == null || cur !== 0 || parsed === cur) continue;
    updates.push({ id: ch.id, value: parsed });
  }
  if (updates.length === 0) return 0;

  const res = await bulkSetField({ playlist_id: tokenPid, field: 'shift', updates });
  if (!res.success) {
    throw new Error(res.message || 'Failed to apply shift from names');
  }
  return updates.length;
}
